
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class PluDtDialog extends Serenity.Extensions.GridEditorDialog<PluDtRow> {
        protected getFormKey() { return PluDtForm.formKey; }
        // protected getIdProperty() { return PluDtRow.idProperty; }
        protected getLocalTextPrefix() { return PluDtRow.localTextPrefix; }
        protected getNameProperty() { return PluDtRow.nameProperty; }
        // protected getService() { return PluDtService.baseUrl; }
        // protected getDeletePermission() { return PluDtRow.deletePermission; }
        // protected getInsertPermission() { return PluDtRow.insertPermission; }
        // protected getUpdatePermission() { return PluDtRow.updatePermission; }

        protected form = new PluDtForm(this.idPrefix);
        //public StkUnit: string;
        public PluDesc: string;

        public sku: string;
        public ratio: number;
        public qty: number;
        public skuCost: number;

        public new: boolean;
        constructor() {
            super();

            this.form = new PluDtForm(this.idPrefix);
            // if (!this.isNew) { } else {
            //     this.form.PluDesc.changeSelect2(e => {
            //         var pludesc = Q.toId(this.form.PluDesc.value);
            //         if (pludesc != null) {


            //             this.PluDesc = this.form.PluDesc.value
            //             this.form.PluShortDesc.value = (this.PluDesc).substring(0, 40);

            //         }
            //     });


            
            this.form.IsActive.change(e => {

                this.ActiveFgT();
            });


            this.form.SellUnitPrice1.changeSelect2(e => {
                var pludesc = Q.toId(this.form.SellUnitPrice1.value);
                console.log(this.new)
                if (this.new == false) {

                } else {
                    if (pludesc != null) {

                        this.form.SellUnitPrice2.value = this.form.SellUnitPrice1.value;
                        this.form.SellUnitPrice3.value = this.form.SellUnitPrice1.value;
                        this.form.SellUnitPrice4.value = this.form.SellUnitPrice1.value;
                        this.form.SellUnitPrice5.value = this.form.SellUnitPrice1.value;
                        this.form.SellUnitPrice6.value = this.form.SellUnitPrice1.value;
                    }
                }
            });



        }

        private ActiveFgT() {
            var a = this.form.IsActive.value;

                console.log(a)

                if (a == true) {
                    // Serenity.EditorUtils.setReadOnly(this.form.ActivePurFg, false);
                    Serenity.EditorUtils.setReadOnly(this.form.ActiveSellFg, false);
                    // return this.form.ActivePurFg.value = true;
                    return this.form.ActiveSellFg.value = true;
                    

                }
                else {
                    // Serenity.EditorUtils.setReadOnly(this.form.ActivePurFg, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ActiveSellFg, true);
                    // return this.form.ActivePurFg.value = false;
                    return this.form.ActiveSellFg.value = false;

                }
        }



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            
            let newBtn: Serenity.ToolButton =
            {
                title: "เพิ่มบารโค๊ดและสร้างรายการถัดไป",
                hint: "Save and new",
                separator: false,
                cssClass: "button-saveandnew",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: (e) => {



                    this.sku = this.form.SkuCode.value;
                    this.ratio = this.form.SellUnitRatio.value;
                    if (!this.isNew()) {
                        var cost = Product.CsSkuRow.getLookup().itemById[this.sku].StockCostValue;
                        this.qty = Product.CsSkuRow.getLookup().itemById[this.sku].QtyOnhand
                    } else { var cost = 1; this.qty = 1 }
                    if (this.qty < 1) {
                        this.skuCost = this.ratio * (cost / (1))
                    } else {
                        this.skuCost = this.ratio * (cost / (this.qty));
                    }


                    // Define a string
                    let str: string = this.form.PluShortDesc.value;

                    // Check if the string contains 
                    let isWorldPresent: boolean = str.includes("^") || str.includes("+");
                    console.log(isWorldPresent)
                    if (isWorldPresent == true) {
                        Q.warning("This " + this.form.PluShortDesc.value + " can't use symbol ^ or + in PluShortDesc data")
                    } else {

                        if (this.form.SellUnitPrice1.value < this.skuCost) {
                            Q.confirm("ราคาต้นทุนสินค้า (ณ ปัจจุบัน) : " + this.skuCost + "\r\n" + "ยืนยันตั้งราคาขายต่ำกว่าราคาทุน", () => {
                                e.preventDefault();
                                this.saveAndNew();
                            });
                        } else {
                            e.preventDefault();
                            this.saveAndNew();
                        }
                    }


                }
            };
            buttons.push(newBtn);

            let gen: Serenity.ToolButton =
            {
                title: "Gen.Barcode",
                hint: "(Gen to 15 digit) โปรดกด Apply ที่สินค้า ทุกครั้งที่มีการใช้ Gennarate Code บน Plu",
                separator: false,
                cssClass: "button-gen",
                icon: "fa fa-magic",
                //hotkey: 'alt+s',
                onClick: (e) => {
                    var self = this;

                    var s = self.form.PluCode.value
                    var x = self.form.SkuCode.value
                    console.log(x)
                    console.log(s)
                    if (s == x) {

                        GeniuzPOS.Product.CsPluService.GetNextNumber({
                            Prefix: s,
                            Length: 13
                        }, response => {

                            self.form.PluCode.value = response.Serial;

                        });
                    } else if (s.length <= 0) {
                        s = '49' + Q.formatDate(new Date(), "ddMMyy")
                        GeniuzPOS.Product.CsPluService.GetNextNumber({
                            Prefix: s,
                            Length: 13
                        }, response => {

                            self.form.PluCode.value = response.Serial;

                        });
                    }
                    else {
                        GeniuzPOS.Product.CsPluService.GetNextNumber({
                            Prefix: s,
                            Length: 13
                        }, response => {

                            self.form.PluCode.value = response.Serial;

                        });
                    }



                }
            };
            buttons.push(gen);

            let gene: Serenity.ToolButton =
            {
                title: "Gen.EAN13",
                hint: "(Gen to 15 digit) โปรดกด Apply ที่สินค้า ทุกครั้งที่มีการใช้ Gennarate Code บน Plu",
                separator: false,
                cssClass: "button-gen",
                icon: "fa fa-magic",
                //hotkey: 'alt+s',
                onClick: (e) => {
                    var self = this;

                    var s = self.form.PluCode.value
                    var x = self.form.SkuCode.value
                    console.log(x)
                    console.log(s)
                    if (s == x) {

                        GeniuzPOS.Product.CsPluService.GetNextNumberEAN({
                            Prefix: s,
                            Length: 13
                        }, response => {

                            self.form.PluCode.value = response.Serial;

                        });
                    } else if (s.length <= 0) {
                        s = '49' + Q.formatDate(new Date(), "ddMMyy")
                        GeniuzPOS.Product.CsPluService.GetNextNumberEAN({
                            Prefix: s,
                            Length: 13
                        }, response => {

                            self.form.PluCode.value = response.Serial;

                        });
                    }
                    else {
                        GeniuzPOS.Product.CsPluService.GetNextNumberEAN({
                            Prefix: s,
                            Length: 13
                        }, response => {

                            self.form.PluCode.value = response.Serial;

                        });
                    }



                }
            };
            buttons.push(gene);
           
            //if (!this.isNew()) {
            let delBtn: Serenity.ToolButton =
            {
                title: "ลบ",
                hint: "Delete",
                separator: false,
                cssClass: "button-newdelete",
                icon: "fa fa-trash",
                hotkey: 'alt+s',
                onClick: (e) => {
                    e.preventDefault();
                    Q.confirm('ยืนยันการลบ', () => {
                        this.doDelete(() => {
                            this.dialogClose();
                        });
                    });
                }
            };
            buttons.push(delBtn);
            // }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
        private saveAndNew() {
            let e = this.entity; let f = this.form;
            // if (e.SkuCode == null) {
            //     e.SkuCode = f.SkuCode.value;

            // }
            this.save((response) => {
                let ent: PluDtRow = { SkuCode: e.SkuCode };
                this.loadEntity(ent);
            });

            // this.save((response) => {
            //     let ent: PluDtRow = {
            //         SkuCode: f.SkuCode.value,
            //         PluDesc: f.PluDesc.value,
            //         StyleId: f.StyleId.value,
            //         ColorId: f.ColorId.value,
            //         MatTypeId: f.MatTypeId.value,
            //         SizeId: f.SizeId.value,
            //         TasteId: f.TasteId.value,
            //         SellUnit: f.SellUnit.value
            //     };
            //     this.loadEntity(ent);
            //     this.toolbar.findButton("button-skucode").text("สร้าง บารโค๊ด");
            //     f.SkuCode.value = ent.SkuCode;
            //     f.PluDesc.value = ent.PluDesc;
            //     f.StyleId.value = ent.StyleId;
            //     f.ColorId.value = ent.ColorId;
            //     f.MatTypeId.value = ent.MatTypeId;
            //     f.SizeId.value = ent.SizeId;
            //     f.TasteId.value = ent.TasteId;
            //     f.SellUnit.value = ent.SellUnit;


            // });
            
        }
        protected beforeLoadEntity() {
            let self = this;



            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
            let f = this.form;
            // if (f.SkuCode.value != null) {
            /* let self = this;*/

            // self.toolbar.findButton("button-skucode").addClass("skuStockStatus");
            // self.toolbar.findButton('button-newdelete').addClass("skuEssential");
            // }

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.syscuscheck();

            if (this.isNew()) {
                this.toolbar.findButton("button-skucode").text("สร้าง บารโค๊ด");
                this.toolbar.findButton("button-newdelete").hide();
                // this.toolbar.findButton("button-gen").hide(); //เปิดฟังชั่นเจนดรอปบรรทัดนี้
                this.new = true

            } else {
                this.toolbar.findButton("button-skucode").text("แก้ไข บารโค๊ด");
                this.toolbar.findButton("button-gen").hide();
                this.new = false
                this.ActiveFgT();
            }

            var Plucheck = Q.tryFirst(ReportMasterData.Report_1201_DtRow.getLookup().items, x => x.PluCode == this.entity.PluCode);
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
            }

            var pos = Q.tryFirst(PosShift.PosTranDtRow.getLookup().items, x => x.PluCode == this.entity.PluCode);
            if (pos != null) {
                this.deleteButton.toggleClass('disabled', true);
            } 
        }

        protected getCssClass() {
            super.getCssClass();
            return "fixRightMaster";

        }


        private syscuscheck() {
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 53 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.PluType.getGridField().toggle(true);
               } else {
               this.form.PluType.getGridField().toggle(false);
            }
        }

    }
}